import React, { useState, useCallback } from 'react'
import { MessageEditorContent } from '@/components/messages/editor-content'

const ComposeMessageResultData = React.memo(({ data, targetInstitution, onChange }) => {
  const [message, setMessage] = useState((data && data.message) || {})
  const [attachments, setAttachments] = useState((data && data.attachments) || [])

  const updateDto = useCallback(data => {
    const newMessage = { ...message, ...data }
    setMessage(newMessage)
    onChange({ message: newMessage, attachments })
  }, [attachments, message, onChange])

  const updateAttachmentsDto = useCallback(data => {
    setAttachments(data)
    onChange({ message, attachments: data })
  }, [message, onChange])

  return <MessageEditorContent
    message={message}
    attachments={attachments}
    updateDto={updateDto}
    updateAttachments={updateAttachmentsDto}
    hideRecipient={!!targetInstitution}
  />
})

export { ComposeMessageResultData }



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/composeMessageResultData.js